/**
 * The internal dashboard is intentionally NOT part of the production deployment.
 * The public 503 page is the only thing served from work.turing.com; the
 * dashboard is hosted separately on Magic Patterns.
 *
 * These host rules make that split explicit in code: on a production Turing
 * host the internal route refuses to render at all, so an accidental deploy
 * of this bundle can never expose telemetry to the public.
 */
const ALLOWED_HOST_SUFFIXES = ['magicpatterns.app', 'magicpatterns.com', 'localhost', '127.0.0.1']

const BLOCKED_HOST_SUFFIXES = ['turing.com']

export function currentHost(): string {
  try {
    return window.location.hostname.toLowerCase()
  } catch {
    return ''
  }
}

export function isInternalHostAllowed(host: string = currentHost()): boolean {
  if (BLOCKED_HOST_SUFFIXES.some(suffix => host === suffix || host.endsWith(`.${suffix}`))) {
    return false
  }
  return ALLOWED_HOST_SUFFIXES.some(suffix => host === suffix || host.endsWith(`.${suffix}`))
}
